import { createTheme } from "@mui/material";

export const COLORS = {
  ink: "#0f1117",
  surface: "#f7f8fc",
  card: "#ffffff",
  border: "#e4e7f0",
  accent: "#4f46e5",
  accentLight: "#eef2ff",
  accentMid: "#818cf8",
  success: "#16a34a",
  successLight: "#f0fdf4",
  warn: "#d97706",
  warnLight: "#fffbeb",
  danger: "#dc2626",
  dangerLight: "#fef2f2",
  muted: "#6b7280",
  textSub: "#9ca3af",
};

const theme = createTheme({
  palette: {
    primary: { main: COLORS.accent },
    background: { default: COLORS.surface, paper: COLORS.card },
    text: { primary: COLORS.ink, secondary: COLORS.muted },
  },
  typography: {
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    h4: { fontWeight: 800 },
    h5: { fontWeight: 800 },
    h6: { fontWeight: 700 },
  },
  shape: { borderRadius: 10 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { textTransform: "none", fontWeight: 600, borderRadius: 8 },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: { borderRadius: 6 },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontWeight: 600 },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          "& .MuiTableCell-head": {
            fontWeight: 700,
            fontSize: 12,
            textTransform: "uppercase",
            letterSpacing: "0.05em",
            color: COLORS.muted,
            backgroundColor: COLORS.surface,
          },
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: { "&:last-child td": { borderBottom: 0 } },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: "none" },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: { borderRadius: 16 },
      },
    },
  },
});

export default theme;
